import { render } from "./ProjectSettings.vue?vue&type=template&id=c29da416&ts=true"
import script from "./ProjectSettings.vue?vue&type=script&lang=ts"
export * from "./ProjectSettings.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__